export default [
    [/\/proofreading-orders\/(\d+)\/show/, '/proofreading-orders/$1/overview'],
];
